import Stickyfill from 'stickyfill';

const stickyfill = Stickyfill();

$(document).ready(() => {
    const stickyElements = document.querySelectorAll('.sticky');
    stickyfill.add(stickyElements);
});
